import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useSpring, animated } from 'react-spring';
import { useTrackVisibility } from 'react-intersection-observer-hook';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} AnimatedNumberCounterPropTypes
 */

export const AnimatedNumberCounter = ({
    toValue = 0,
    onEnd = () => {},
    decimalPlaces = null,
    decimalSeparator = '.'
}) => {
    const [ref, { wasEverVisible }] = useTrackVisibility();
    const [ended, setEnded] = useState(false);

    toValue = Number(toValue);

    const { number } = useSpring({
        number: (wasEverVisible ? toValue : 0),
        from: { number: 0 },
        delay: 200,
        config: { mass: 1, tension: 30, friction: 10 },
        onChange: (result) => {
            if (result.value.number === toValue) {
                setEnded(true);
                onEnd();
            }
        }
    });

    if (isNaN(decimalPlaces) && toValue % 1 !== 0) {
        decimalPlaces = toValue.toString().split('.')[1].length;
    }

    const format = (val) => val.toFixed(decimalPlaces).replace('.', decimalSeparator);
    const output = number.to(format);

    return (
        <div className='w-min'>
            {ended && (
                <p>
                    {decimalPlaces !== 0 && format(toValue)}
                    {decimalPlaces === 0 && toValue}
                </p>
            )}
            {!ended && (
                <animated.p ref={ref}>
                    {output}
                </animated.p>
            )}
        </div>
    );
};

const amimatedNumberCounterPropTypes = {
    toValue: PropTypes.number.isRequired,
    onEnd: PropTypes.func,
    decimalPlaces: PropTypes.number,
    decimalSeparator: PropTypes.string,
};

AnimatedNumberCounter.propTypes = amimatedNumberCounterPropTypes;

export default AnimatedNumberCounter;
